function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "path3349",
  fill: "#C3C3C3",
  d: "M7.266,29.154l0.523-3.321l-1.165-0.027H1.061L4.927,1.292       C4.939,1.218,4.978,1.149,5.035,1.1c0.057-0.049,0.13-0.076,0.206-0.076h9.38c3.114,0,5.263,0.648,6.385,1.927       c0.526,0.6,0.861,1.227,1.022,1.917c0.171,0.724,0.174,1.589,0.008,2.644l-0.012,0.077v0.676l0.525,0.298       c0.443,0.235,0.795,0.504,1.065,0.812c0.45,0.513,0.741,1.165,0.864,1.938c0.127,0.795,0.084,1.741-0.123,2.812       c-0.24,1.232-0.629,2.305-1.152,3.183c-0.482,0.81-1.096,1.479-1.825,2c-0.696,0.493-1.522,0.868-2.458,1.108       c-0.906,0.236-1.939,0.355-3.072,0.355h-0.729c-0.522,0-1.029,0.188-1.427,0.525c-0.399,0.344-0.664,0.813-0.745,1.328l-0.055,0.299       l-0.924,5.854l-0.042,0.216c-0.011,0.067-0.03,0.102-0.058,0.125c-0.025,0.021-0.061,0.034-0.096,0.034H7.266z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "bottom-p",
  fill: "#BFBFBF",
  d: "M23.048,7.667L23.048,7.667L23.048,7.667       c-0.027,0.179-0.061,0.362-0.096,0.55c-1.237,6.351-5.469,8.545-10.874,8.545H9.326c-0.661,0-1.218,0.48-1.321,1.132l0,0l0,0       l-1.409,8.937l-0.399,2.532c-0.067,0.429,0.263,0.813,0.695,0.813h4.881c0.578,0,1.069-0.42,1.16-0.989l0.048-0.248l0.918-5.832       l0.06-0.319c0.09-0.572,0.582-0.992,1.16-0.992h0.729c4.729,0,8.432-1.92,9.514-7.477c0.451-2.321,0.218-4.259-0.979-5.622       C24.022,8.286,23.573,7.945,23.048,7.667z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "intersection",
  fill: "#F4F4F4",
  d: "M21.754,7.151c-0.188-0.055-0.384-0.105-0.584-0.15       c-0.201-0.044-0.407-0.083-0.619-0.117c-0.741-0.12-1.555-0.177-2.426-0.177h-7.352c-0.181,0-0.353,0.041-0.507,0.115       C9.927,6.985,9.675,7.306,9.614,7.699L8.05,17.605l-0.045,0.289c0.103-0.651,0.66-1.132,1.321-1.132h2.752       c5.405,0,9.637-2.195,10.874-8.545c0.037-0.188,0.068-0.371,0.096-0.55c-0.312-0.166-0.652-0.308-1.018-0.429       C21.94,7.208,21.849,7.179,21.754,7.151z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "top-p",
  fill: "#E0E0E0",
  d: "M9.614,7.699c0.061-0.393,0.313-0.714,0.652-0.876       c0.155-0.074,0.326-0.115,0.507-0.115h7.352c0.871,0,1.685,0.057,2.426,0.177c0.212,0.034,0.418,0.073,0.619,0.117       c0.2,0.045,0.396,0.095,0.584,0.15c0.095,0.028,0.187,0.057,0.278,0.086c0.365,0.121,0.703,0.264,1.017,0.429       c0.368-2.347-0.003-3.945-1.272-5.392C20.378,0.682,17.853,0,14.622,0h-9.38c-0.66,0-1.223,0.48-1.325,1.133L0.01,25.898       c-0.077,0.49,0.301,0.933,0.795,0.933h5.791l1.454-9.226L9.614,7.699z"
});

function SvgPaypalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsxllink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25.576px",
    height: "30.176px",
    viewBox: "0 0 25.576 30.176",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalIcon);
export default __webpack_public_path__ + "static/media/paypal-icon.af43bb67.svg";
export { ForwardRef as ReactComponent };